<script setup lang="ts">
import Button from '~/ui/Button.vue'
import Gap from '~/ui/Gap.vue'
import { useI18n } from 'vue-i18n'

defineProps<{ goNext?: () => void, goPrevious?: () => void }>()

const { t } = useI18n()
</script>

<template>
  <slot />
  <nav
    class="layout-row"
    ui-span-all
  >
    <Button
      class="color-default-ghost shape-field-minimal"
      :disabled="!goPrevious"
      :aria-label="t('vui.aria.pagination.gotoPrevious')"
      @click="goPrevious?.()"
    >
      <span class="iconify logical-previous" />
      {{ t('vui.pagination.previous') }}
    </Button>
    <Gap />
    <Button
      class="color-default-ghost shape-field-minimal"
      :disabled="!goNext"
      :aria-label="t('vui.aria.pagination.gotoNext')"
      @click="goNext?.()"
    >
      {{ t('vui.pagination.next') }}
      <span class="iconify logical-next" />
    </Button>
  </nav>
</template>
